import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import edinburghCastle from '../assets/edinburgh_castle.jpg';
import './css/auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    // Basic validation
    if (!formData.email || !formData.password) {
      setError('Please enter both email and password');
      return;
    }
    
    setIsLoading(true);
    
    // For demo purposes, simulate a login process
    setTimeout(() => {
      // This is a mock validation - in a real app, this would be a server request
      if (formData.email.includes('@') && formData.password.length >= 6) {
        console.log('Login successful!', formData);
        alert('Login successful! This is a demo, so no actual authentication has occurred.');
      } else {
        setError('Invalid email or password');
      }
      setIsLoading(false);
    }, 1500);
  };

  return (
    <div className="auth-container">
      <motion.div 
        className="auth-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="auth-header">
          <h2>Welcome Back</h2>
          <p>Log in to continue your Edinburgh adventure</p>
        </div>
        
        {error && <div className="auth-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email@example.com"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
              minLength="6"
            />
          </div>
          
          <div className="form-extras">
            <div className="remember-me">
              <input
                type="checkbox"
                id="remember"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <label htmlFor="remember">Remember me</label>
            </div>
            <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
          </div>
          
          <button 
            type="submit" 
            className="auth-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading-spinner"></span>
            ) : 'Log In'}
          </button>
        </form>
        
        <div className="auth-divider">
          <span>or</span>
        </div>
        
        <div className="social-login">
          <button className="social-button google">
            <span className="social-icon">G</span>
            Sign in with Google
          </button>
          <button className="social-button facebook">
            <span className="social-icon">f</span>
            Sign in with Facebook
          </button>
        </div>
        
        <div className="auth-footer">
          <p>Don't have an account? <Link to="/register">Register Now</Link></p>
        </div>
      </motion.div>
      
      <div className="auth-decoration">
        <div className="auth-bg-image" style={{backgroundImage: `url(${edinburghCastle})`}}></div>
        <div className="auth-quote">
          <blockquote>
            "Edinburgh is a city of shifting light, of changing skies, of sudden vistas. A city so beautiful it breaks the heart again and again."
          </blockquote>
          <cite>- Alexander McCall Smith</cite>
        </div>
      </div>
    </div>
  );
};

export default Login;